/**
 * Emit hosts for the `force-update` analytics group — 3 functions
 * lifted out of `analyticsScribeModel`'s effects so a call site can emit
 * without holding a Rematch `dispatch`. Every payload is the effect's own.
 */
import { track } from '@/lib/analytics/track';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import {
  type ForceUpdateDeferredEventProps,
  type ForceUpdateInitiatedEventProps,
  type ForceUpdateViewedEventProps,
} from '@/models/analytics/features/forceUpdate';

export function trackForceUpdateDeferred(input: ForceUpdateDeferredEventProps) {
  track({
    event_name: TrackingEventName.ForceUpdateDeferred,
    props: {
      current_version: input.current_version,
      min_supported_version: input.min_supported_version,
      deadline_at: input.deadline_at,
    },
  });
}

export function trackForceUpdateInitiated(input: ForceUpdateInitiatedEventProps) {
  track({
    event_name: TrackingEventName.ForceUpdateInitiated,
    props: {
      update_type: input.update_type,
      current_version: input.current_version,
      min_supported_version: input.min_supported_version,
    },
  });
}

export function trackForceUpdateViewed(input: ForceUpdateViewedEventProps) {
  track({
    event_name: TrackingEventName.ForceUpdateViewed,
    props: {
      update_type: input.update_type,
      reason: input.reason,
      current_version: input.current_version,
      min_supported_version: input.min_supported_version,
      deadline_at: input.deadline_at,
    },
  });
}
